import Hero from "./Hero";
import Features from "./Features";
import CTASection from "./CTASection";
import PartnerCarousel from "./PartnerCarousel";
// import Testimonials from "./Testimonials";
import Recents from "./Recents";
import SeoMeta from "../SeoMeta";
import CoursePromoAd from "../courses/CoursePromoAd";

export default function HomePage() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Code Arena",
    url: "https://www.code-arena.in",
    description:
      "Learn Golang from scratch with hands-on coding challenges, MCQs & hidden test cases. Find freshers IT jobs, internships & referrals in India.",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://www.code-arena.in/jobs?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <>
      <SeoMeta
        title="Code Arena – Learn Golang Free | Freshers IT Jobs, Internships & Referrals India 2025"
        description="Master Golang programming from zero to hero with real-time code execution, hidden test cases & MCQs. Find freshers IT jobs, off-campus placements, internships & referrals. Start your tech career today!"
        url="https://www.code-arena.in/"
        image="/logo192.png"
        keywords="learn golang, golang course, golang tutorial, golang for beginners, go programming, freshers jobs India, fresher IT jobs, off-campus jobs 2025, IT internships, job referrals, coding bootcamp, golang practice, software developer jobs, entry level jobs, golang coding challenges, tech jobs freshers"
        jsonLd={jsonLd}
      />
      <Hero />
      <Features />
      <div className="ca-container py-8">
        <CoursePromoAd />
      </div>
      <CTASection />
      <Recents />
      <PartnerCarousel />
      {/* <Testimonials /> */}
    </>
  );
}
